module.exports = __webpack_public_path__ + "img/connected.a2e922ca.png";